import React from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { i18n } from 'constant/String';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import {
  REGEX_EMAIL,
  REGEX_FULLNAME,
  REGEX_NUMERIC,
} from 'constant/Validation';
import { FormProvider, useForm } from 'react-hook-form';
import { isUserCompanySelector } from 'redux/slices/signUp/signUpSlice';
import UserInfoForm from './UserInfoForm';
import { useSelector } from 'react-redux';

const UserInfoModule = ({ onSubmit }) => {
  const isUserCompany = useSelector(isUserCompanySelector);
  const individualSchema = yup
    .object({
      fullName: yup
        .string()
        .required(i18n.errors.required)
        .test('hasNoNumbers', i18n.errors.fullNameNumeric, (value) => {
          return !REGEX_NUMERIC.test(value);
        })
        .test('hasSpace', i18n.errors.fullName, (value) => {
          return REGEX_FULLNAME.test(value);
        }),
      identityNumber: yup
        .string()
        .required(i18n.errors.required)
        .min(11, i18n.errors.tcMin)
        .max(11, i18n.errors.tcMax)
        .nullable(),
      email: yup
        .string()
        .required(i18n.errors.required)
        .matches(REGEX_EMAIL, i18n.errors.email),
      username: yup.string().required(i18n.errors.required),
      companyName: yup.string().required(i18n.errors.required),
      telephone: yup.string().required(i18n.errors.required),
    })
    .required(i18n.errors.required);
  const companySchema = yup
    .object({
      fullName: yup
        .string()
        .required(i18n.errors.required)
        .test('hasNoNumbers', i18n.errors.fullNameNumeric, (value) => {
          return !REGEX_NUMERIC.test(value);
        })
        .test('hasSpace', i18n.errors.fullName, (value) => {
          return REGEX_FULLNAME.test(value);
        }),
      email: yup
        .string()
        .required(i18n.errors.required)
        .matches(REGEX_EMAIL, i18n.errors.email),
      username: yup.string().required(i18n.errors.required),
      telephone: yup.string().required(i18n.errors.required),
      taxNumber: yup
        .string()
        .required(i18n.errors.required)
        .min(10, i18n.errors.vergMin)
        .max(11, i18n.errors.vergMax)
        .nullable(),
      companyName: yup.string().required(i18n.errors.required),
    })
    .required(i18n.errors.required);

  const methods = useForm({
    resolver: yupResolver(isUserCompany ? companySchema : individualSchema),
  });

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(onSubmit)}
        className="flex flex-col overflow-auto w-full gap-y-4 md:mt-10 items-center justify-center  h-full"
      >
        <UserInfoForm onSubmit={onSubmit} />
      </form>
    </FormProvider>
  );
};

UserInfoModule.propTypes = { onSubmit: PropTypes.func };
export default UserInfoModule;
